import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { login } from "../../../actions/auth.action";
import ErrorInputComponent from "../../../components/ErrorInputComponent";
import ButtomButton from "../../../components/DocButtomButton";
import { Loading } from "../../../utils/helpers/constants";
import {
  SignInContainer,
  FormCard,
  LogoContainer,
  // ForgotPassword,
  // BtnQuestion,
} from "./style";
import Logo from "../../../assets/images/png/luaa_logo.png";

export default function SignIn() {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    auth: { loginStatus },
  } = useSelector(({ authReducer }) => ({
    auth: authReducer,
  }));

  const forgetPassword = () => {
    history.push("/forgot-password");
  };

  const validationSchema = Yup.object({
    matricNumber: Yup.string().required("Matric number is required"),
    password: Yup.string().required("Password is required"),
  });
  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      matricNumber: "",
      password: "",
    },
    validationSchema,
    onSubmit(values) {
      const payload = {
        matricNumber: values.matricNumber,
        password: values.password,
      };
      const link = () => history.push("/");
      dispatch(login(payload, link));
    },
  });

  const buttonLoadState = loginStatus === Loading.FETCHING;

  return (
    <SignInContainer>
      <img src={Logo} alt="logo" className="top-logo" />
      <FormCard>
        <div>
          <LogoContainer>
            <img src={Logo} alt="logo" className="inner-logo" />
          </LogoContainer>
          <h3>Welcome</h3>
          <p>You should create an exceptional experience when you do things</p>
        </div>
        <form className="mt-10" onSubmit={handleSubmit}>
          <input
            className="appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="text"
            name="matricNumber"
            onChange={handleChange}
            placeholder="Matric Number"
          />
          <ErrorInputComponent error={errors.matricNumber} />
          <input
            className="mt-5 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="password"
            name="password"
            onChange={handleChange}
            placeholder="Password"
          />
          <ErrorInputComponent error={errors.password} />
        </form>

        <div className="flex justify-between mt-5 compass_color">
          <span
            className="cursor-pointer"
            onClick={() => history.push("/onboarding/activate-account")}
          >
            Activate account
          </span>
          <span className="cursor-pointer" onClick={() => forgetPassword()}>
            Forgot password?
          </span>
        </div>
        <ButtomButton
          loading={buttonLoadState}
          name={"Login"}
          func={() => handleSubmit()}
        />
      </FormCard>
    </SignInContainer>
  );
}
